module.exports = __webpack_public_path__ + "static/img/2.ce75694a.jpg";